module.exports = __webpack_public_path__ + "img/thumb-preview-start.svg";